
module.filter('dolRegionNumber', function(dolRegions) {
    return function(state) {
        return dolRegions[state.toUpperCase()];
    };
});
